import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectAssortmentItemsData = createSelector([selectAssortmentState], (state) => {
  return state.items.data
})
